import { MantineProvider } from '@mantine/core'
import { NextIntlClientProvider } from 'next-intl'

import { defaultColorScheme } from '@/configs'
import SsrContextProvider from '@/contexts/providers/SsrContextProvider'
import { TanstackQueryClientProvider } from '@/libs/tanstack-query'
import resolver from '@/styles/resolver'
import { theme } from '@/styles/theme'
import { RequestUserAgent } from '@/types/global'

interface AppProvidersProps {
  children: React.ReactNode
  messages: Record<string, any>
  requestUserAgent: RequestUserAgent
  selectedCurrency: string
  locale?: string
  countryCode: string
}

export default function AppProviders({
  children,
  messages,
  locale,
  requestUserAgent,
  selectedCurrency,
  countryCode,
}: AppProvidersProps) {
  return (
    <NextIntlClientProvider messages={messages} locale={locale}>
      <MantineProvider
        defaultColorScheme={defaultColorScheme}
        theme={theme}
        cssVariablesResolver={resolver}
      >
        <SsrContextProvider
          requestUserAgent={requestUserAgent}
          selectedCurrency={selectedCurrency}
          countryCode={countryCode}
        >
          <TanstackQueryClientProvider>{children}</TanstackQueryClientProvider>
        </SsrContextProvider>
      </MantineProvider>
    </NextIntlClientProvider>
  )
}
